
<template>
  <div class="CollaborativeEducation" v-html="resData.instructions">

  </div>
</template>

<script>
export default {
  name: 'CollaborativeEducation',
  data () {
    return {
      resData: {}
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const that = this
      this.$request.getTionList().then((res) => {
        if (res.code === 200) {
          // console.log(res)
          that.$set(that, 'resData', res.data)
        }
      })
    }
  },
}
</script>

<style lang="scss" >
.CollaborativeEducation {
  position: relative;
  p {
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-align: justify;
    padding-bottom: 20px;
    text-indent: 32px;
    &:last-child {
      padding-bottom: 0;
    }
  }
}
</style>